// extracted by mini-css-extract-plugin
export default {"Box_0":"StyledInput-module__Box_0--fI46v","Box_1":"StyledInput-module__Box_1--_Dcqj","Box_2":"StyledInput-module__Box_2--JRyid","KeyBlock_0":"StyledInput-module__KeyBlock_0--Y18rv"};